import { useMemo } from "react";
import { Conversation } from "@/app/@types/message";

const useTotalUnreadCount = (conversations: Conversation[]) => {
  const totalUnread = useMemo(() => {
    return conversations.reduce((sum, c) => sum + (c.unreadCount || 0), 0);
  }, [conversations]);

  return totalUnread;
};

export default useTotalUnreadCount;
